import { Config } from '../config';

export interface PublicChangeData {
    _id: string;
    title: Record<string, string>;
    description?: Record<string, string>;
    type?: string;
    slug?: number;
    project?: { _id: string; name: string };
}

class PublicChanges {
    baseUrl: string;

    constructor() {
        this.baseUrl = Config.api_end_point;
    }

    getPublic(changeId: string): Promise<PublicChangeData> {
        const normalizedBaseUrl = this.baseUrl.replace(/\/+$/, '');
        const apiBaseUrl = normalizedBaseUrl.endsWith('/api/v1') ?
            normalizedBaseUrl :
            `${normalizedBaseUrl}/api/v1`;

        return fetch(`${apiBaseUrl}/changes/${changeId}/public`, {
            method: 'GET',
            headers: { 'Accept': 'application/json' },
        })
            .then(response => {
                if (!response.ok)
                    throw new Error(`HTTP ${response.status}`);
                return response.json();
            })
            .then(json => {
                if (json.change)
                    return json.change as PublicChangeData;
                throw new Error(json.error || 'Not found');
            });
    }
}

const PublicChangesApi = new PublicChanges();
export default PublicChangesApi;
